import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex min-h-[60vh] flex-col items-center justify-center px-4 py-20 text-center md:px-8">
      <p className="font-heading text-7xl font-700 text-primary-500 md:text-9xl">404</p>
      <h1 className="mt-6 font-heading text-2xl font-700 text-foreground-950 md:text-3xl">页面走丢了</h1>
      <p className="mt-3 font-mono text-sm text-foreground-500">{location.pathname}</p>
      <p className="mt-3 max-w-md text-sm leading-6 text-foreground-400">
        你访问的页面不存在或已被移除，回到首页继续探索精彩的影视内容吧。
      </p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex h-11 items-center gap-2 rounded-md bg-primary-500 px-6 text-sm font-500 text-background-950 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line text-base" aria-hidden="true"></i>
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="inline-flex h-11 items-center gap-2 rounded-md border border-background-300 px-6 text-sm font-500 text-foreground-300 transition-colors hover:border-primary-500 hover:text-primary-400"
        >
          <i className="ri-film-line text-base" aria-hidden="true"></i>
          去看电影
        </Link>
      </div>
    </div>
  );
}